import Vue from "vue";
import {
  message,
  Modal
} from "ant-design-vue";

const namespaced = true;

function initialState() {
  return {
    projects: {}
  };
}

const state = {
  projects: initialState().projects
};

const mutations = {
  SET_PROJECT: (state, project) => {
    Vue.set(state.projects, project.id, project);
  },
  UNSET_PROJECT: (state, id) => {
    Vue.delete(state.projects, id);
  }
};

const actions = {
  create: ({
    commit
  }, project) => {
    return new Promise((resolve, reject) => {
      Vue.axios
        .post(`/admin/project`, {
          project: project
        })
        .then(response => {
          commit("SET_PROJECT", response.data.project);
          resolve();
        })
        .catch(error => {
          Vue.prototype.$log.error(error);
          reject(error);
        });
    });
  },
  fetchSingle: ({
    commit
  }, {
    id,
    isPublic
  }) => {
    return new Promise((resolve, reject) => {
      Vue.axios
        .get(`${isPublic ? '/public' : ''}/project/${id}`)
        .then(response => {
          commit("SET_PROJECT", response.data.project);
          resolve(response.data.project);
        })
        .catch(error => {
          Vue.prototype.$log.error(error);
          reject(error);
        });
    });
  },
  fetchAll: ({
    commit
  }) => {
    return new Promise((resolve, reject) => {
      Vue.axios
        .get(`/project`)
        .then(response => {
          for (const project of response.data.projects) {
            commit("SET_PROJECT", project);
          }
          resolve();
        })
        .catch(error => {
          Vue.prototype.$log.error(error);
          reject(error);
        });
    });
  },
  update: ({
    commit
  }, project) => {
    return new Promise((resolve, reject) => {
      Vue.axios
        .put(`/admin/project/${project.id}`, {
          project: project
        })
        .then(response => {
          commit("SET_PROJECT", response.data.project);
          resolve(response.data.project);
        })
        .catch(error => {
          Vue.prototype.$log.error(error);
          reject(error);
        });
    });
  },
  delete: ({
    commit
  }, id) => {
    return new Promise((resolve, reject) => {

      Modal.confirm({
        title: 'Delete booking',
        content: `Permanently delete project. Continue?`,
        okText: 'Yes',
        okType: 'danger',
        cancelText: 'Cancel',
        onOk: () => {
          Vue.axios
            .delete(`/admin/project/${id}`)
            .then(response => {
              commit("UNSET_PROJECT", id);
              resolve();
            })
            .catch(error => {
              Vue.prototype.$log.error(error);
              reject(error);
            });
        }
      });


    });
  }
};

const getters = {
  all: (state, getters, rootState) => {
    if (rootState.isLoading) return {};
    return state.projects;
  },
  asArray: (state, getters, rootState) => {
    if (rootState.isLoading) return [];
    return Object.values(state.projects);
  }
};

export default {
  namespaced,
  state,
  mutations,
  actions,
  getters
};